import {
  type UseMutationOptions,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import type {
  PostV1OrganizationsByOrganizationIdAssignmentsResponse,
  PostV1OrganizationsByOrganizationIdAssignmentsError,
  PostV1OrganizationsByOrganizationIdAssignmentsData,
  Assignment,
} from "../../../client";
import { postV1OrganizationsByOrganizationIdAssignmentsMutation } from "../../../client/@tanstack/react-query.gen";
import { getAssignmentsQueryKey } from "./get-assignments";
import type { Options } from "@hey-api/client-fetch";

export const useCreateAssignment = (
  options: UseMutationOptions<
    PostV1OrganizationsByOrganizationIdAssignmentsResponse,
    PostV1OrganizationsByOrganizationIdAssignmentsError,
    Options<PostV1OrganizationsByOrganizationIdAssignmentsData>
  > = {},
) => {
  const queryClient = useQueryClient();

  return useMutation({
    ...postV1OrganizationsByOrganizationIdAssignmentsMutation(),
    ...options,

    onSuccess: (assignment, variables, context) => {
      queryClient.setQueryData(
        getAssignmentsQueryKey(variables.path.organizationID),
        (oldData: Assignment[] | undefined) => {
          const newAssignment = assignment as Assignment;
          if (!oldData) return [newAssignment];
          return [newAssignment, ...oldData];
        },
      );

      options.onSuccess?.(assignment, variables, context);
    },

    onSettled: (data, error, variables, context) => {
      queryClient.invalidateQueries({
        queryKey: getAssignmentsQueryKey(variables.path.organizationID),
      });
      options.onSettled?.(data, error, variables, context);
    },
  });
};
